/* @ngInject */

export default (
  $rootScope,
  dateTimeService,
  Address,
  PersonalTitle,
  AssetFinanceDetailAdditionalInfo,
  ASSET_FINANCE
) => {
  /* @ngInject */

  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceDetail(
    id,
    age,
    additionalInfo,
    type,
    vehicle,
    estimatedComplianceDate,
    vendor,
    assetLocation,
    description,
    cost,
    primaryCost,
    costInfo,
    deposit,
    calculatedDeposit,
    netCost,
    isTrade,
    trade,
    isTradeEquityApplied
  ) {
    this.id = id;
    this.age = age;
    this.additionalInfo = additionalInfo;
    this.type = type;
    this.vehicle = vehicle;
    this.estimatedComplianceDate = estimatedComplianceDate;
    this.vendor = vendor;
    this.assetLocation = assetLocation;
    this.description = description;
    this.cost = cost;
    this.primaryCost = primaryCost;
    this.costInfo = costInfo;
    this.deposit = deposit;
    this.calculatedDeposit = calculatedDeposit;
    this.netCost = netCost;
    this.isTrade = isTrade;
    this.trade = trade;
    this.isTradeEquityApplied = isTradeEquityApplied;

    _.each(this.vendor, (val, key, obj) => {
      if (key === 'contactTitle' && typeof val === 'number') {
        if (val === 0) {
          obj[key] = PersonalTitle.none;
        }
        if (val === 1) {
          obj[key] = PersonalTitle.mr;
        }
        if (val === 2) {
          obj[key] = PersonalTitle.ms;
        }
        if (val === 3) {
          obj[key] = PersonalTitle.mrs;
        }
        if (val === 4) {
          obj[key] = PersonalTitle.dr;
        }
        if (val === 5) {
          obj[key] = PersonalTitle.miss;
        }
      }
      if (key === 'contactTitle' && typeof val !== 'number') {
        obj[key] = PersonalTitle.of(val?.name);
      }
    });
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceDetail.Blank = function () {
    return AssetFinanceDetail.Build({
      id: _.uuid(),
      age: 0,
      additionalInfo: {},
      type: 0,
      vehicle: {
        type: 0,
        kilometers: 0,
        kilometersInfo: 0,
        hours: 0,
        make: '',
        model: '',
        year: 0,
        variant: '',
        style: '',
        transmission: '',
        series: '',
        engine: '',
        engineNumber: '',
        registrationNumber: '',
        vinChassis: '',
        nvic: ''
      },
      estimatedComplianceDate: '',
      vendor: {
        idContact: '',
        type: 0,
        name: '',
        entityNumber: '',
        phoneCode: '',
        phone: '',
        faxCode: '',
        fax: '',
        email: '',
        address: Address.blank(),
        contactTitle: PersonalTitle.none,
        contactFirstName: '',
        contactSurname: ''
      },
      assetLocation: '',
      description: '',
      cost: 0,
      primaryCost: 0,
      costInfo: 0,
      deposit: 0,
      calculatedDeposit: 0,
      netCost: 0,
      isTrade: false,
      trade: {
        description: '',
        value: 0,
        lender: '',
        lenderOtherName: '',
        payOutOn: 0,
        balance: 0,
        isPayout: false
      },
      isTradeEquityApplied: false
    });
  };

  AssetFinanceDetail.Build = function (data) {
    return new AssetFinanceDetail(
      data.id ? data.id : _.uuid(),
      data.age ? data.age : 0,
      data.additionalInfo ? AssetFinanceDetailAdditionalInfo.build(data.additionalInfo) : {},
      data.type ? data.type : 0,
      data.vehicle
        ? data.vehicle
        : {
            type: 0,
            kilometers: 0,
            kilometersInfo: 0,
            hours: 0,
            make: '',
            model: '',
            year: 0,
            variant: '',
            style: '',
            transmission: '',
            series: '',
            engine: '',
            engineNumber: '',
            registrationNumber: '',
            vinChassis: '',
            nvic: ''
          },
      data.estimatedComplianceDate ? data.estimatedComplianceDate : '',
      data.vendor
        ? data.vendor
        : {
            idContact: '',
            type: 0,
            name: '',
            entityNumber: '',
            phoneCode: '',
            phone: '',
            faxCode: '',
            fax: '',
            email: '',
            address: Address.blank(),
            contactTitle: PersonalTitle.none,
            contactFirstName: '',
            contactSurname: ''
          },
      data.assetLocation ? data.assetLocation : '',
      data.description ? data.description : '',
      data.cost ? data.cost : 0,
      data.primaryCost ? data.primaryCost : 0,
      data.costInfo ? data.costInfo : 0,
      data.deposit ? data.deposit : 0,
      data.calculatedDeposit ? data.calculatedDeposit : 0,
      data.netCost ? data.netCost : 0,
      data.isTrade || false,
      data.trade
        ? data.trade
        : {
            description: '',
            value: 0,
            lender: '',
            lenderOtherName: '',
            payOutOn: 0,
            balance: 0,
            isPayout: false
          },
      data.isTradeEquityApplied || false
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceDetail.prototype.availableAssetTypes = function () {
    return _.sortBy(ASSET_FINANCE.DETAILS.ASSET_TYPE, 'weight');
  };
  AssetFinanceDetail.prototype.availableAssetAges = function () {
    return _.sortBy(ASSET_FINANCE.DETAILS.ASSET_AGE, 'weight');
  };
  AssetFinanceDetail.prototype.availableCarTypes = function () {
    return _.sortBy(ASSET_FINANCE.DETAILS.CAR_TYPE, 'weight');
  };
  AssetFinanceDetail.prototype.availableVendorTypes = function () {
    return _.sortBy(ASSET_FINANCE.DETAILS.VENDOR_TYPE, 'weight');
  };
  AssetFinanceDetail.prototype.getName = function () {
    const { type } = this;
    const name = _.find(this.availableAssetTypes(), (n) => n.id === type);
    return name !== undefined && name.id !== '' ? name.value : 'N/A';
  };
  AssetFinanceDetail.prototype.getMake = function () {
    return this.vehicle.make;
  };
  AssetFinanceDetail.prototype.getModel = function () {
    return this.vehicle.model;
  };
  AssetFinanceDetail.prototype.getAge = function () {
    const { age } = this;
    const name = _.find(this.availableAssetAges(), (n) => n.id === age);
    return name !== undefined ? name.value : 'N/A';
  };
  AssetFinanceDetail.prototype.getSetEstimatedComplianceDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (this.estimatedComplianceDate === '') {
          this.estimatedComplianceDateObject = '';
        }
        const estimatedComplianceDateObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.estimatedComplianceDateObject = date;
        this.estimatedComplianceDate = moment
          .utc(estimatedComplianceDateObject)
          .startOf('day')
          .format('X');
      } else {
        this.estimatedComplianceDateObject = date;
        this.estimatedComplianceDate = '';
      }
    }
    if (!this.estimatedComplianceDateObject) {
      if (this.estimatedComplianceDate !== '') {
        const estimatedComplianceDateObject = dateTimeService.setDate(
          this.estimatedComplianceDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.estimatedComplianceDateObject = estimatedComplianceDateObject;
      } else {
        this.estimatedComplianceDateObject = '';
      }
    }
    return this.estimatedComplianceDateObject;
  };
  AssetFinanceDetail.prototype.deleteDateObject = function () {
    delete this.estimatedComplianceDateObject;
  };

  return AssetFinanceDetail;
};
